import type { UseBookingFormReturnType } from "@calcom/features/bookings/Booker/hooks/useBookingForm";
import type { BookerState } from "@calcom/features/bookings/Booker/types";
import type { BookerEvent } from "@calcom/features/bookings/types";

// PremiumCell: never skip the confirmation step. CRM bookings arrive with name/email/phone
// prefilled, which would otherwise satisfy the booking schema and let cal.com book a slot on a
// single tap (its "skip confirm" shortcut). We always want the rep to review the prefilled
// details before confirming, so the form step is never skipped on this instance.
export const useSkipConfirmStep = (
  _bookingForm: UseBookingFormReturnType["bookingForm"],
  _bookerState: BookerState,
  _isWeekView: boolean,
  _bookingFields?: BookerEvent["bookingFields"],
  _locations?: BookerEvent["locations"]
) => {
  return false;
};
